// test2654
(2654 && 0);
